import axios from 'axios';
import { ENVIRONMENT, ENVIRONMENT_CONSTANTS } from '../common/constants';

const env = process.env[ENVIRONMENT] || 'dev';

const defaultCountryResponse = 'US';

const errorCase = () => defaultCountryResponse; // default if we dont get a country back from a 200 response

const getCountryFromResponse = (res) => res.split(',')[0].split('=')[1];

const localeRender = (response) => {
  if (response.status === 200) {
    const res = response.headers['x-edgescape-location'];
    if (res) {
      return getCountryFromResponse(res);
    }
    return errorCase();
  }
  return errorCase();
};

const getUserCountry = async () => {
  try {
    const res = await axios.get(ENVIRONMENT_CONSTANTS[env].USER_COUNTRY_SERVICE_URL);
    return localeRender(res);
  } catch (error) {
    return errorCase();
  }
};

export {
  defaultCountryResponse, getUserCountry,
};
